import { I18n } from './i18n';

export enum PageType {
  BusinessInfo = 'business_info',
  UserSignup = 'lead_success_user_signup',
  UserReturn = 'lead_success_user_return',
  Inbound = 'lead_success_inbound',
}

export const trackEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel: string,
): void => {
  if (typeof ga !== 'function') {
    return;
  }
  ga('send', 'event', eventCategory, eventAction, eventLabel);
};

export const trackPage = (pageUrl: string, type: PageType): void => {
  window.OptimizeSuite.treatAsNewPage(window.location.href, { page: { type } });
  if (typeof ga !== 'function') {
    return;
  }
  ga('set', 'page', pageUrl);
  ga('send', 'pageview');
};

export const trackGoogleConversionAndFB = (): void => {
  if (typeof window.google_trackConversion !== 'function') {
    return;
  }

  window.google_trackConversion({
    google_conversion_id: 1009250508,
    google_conversion_language: 'en',
    google_conversion_format: '3',
    google_conversion_color: 'ffffff',
    google_conversion_label: 'uIjdCLzZugQQzOGf4QM',
    google_conversion_value: 1.0,
    google_conversion_currency: 'USD',
    google_remarketing_only: false,
  });

  if (typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('init', '2026786494278288');
  window.fbq('track', 'Lead');
};

export const trackBloodhoundEvent = (eventAction: string, eventLabel: string) => {
  window.OptimizeSuite.TrackingHub.add(eventAction, {
    eventLabel,
  });
};
